import ItemsScrollBar from '@wconcept/wconcept-ui-renewal/components/atoms/ItemsScrollBar';
import * as S from './style';

const RecoStylingSkeleton = () => (
  <S.Box className="recommend-styling-skeleton">
    <ItemsScrollBar perView={2.991} offsetLR={20} colGap={6}>
      <div className="item">
        <div />
      </div>
      <div className="item">
        <div />
      </div>
      <div className="item">
        <div />
      </div>
    </ItemsScrollBar>
  </S.Box>
);

export default RecoStylingSkeleton;
